import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {getReview as getReviewQuery} from 'nutshell-graphql-types';

import GET_REVIEW from '../queries/get-review.graphql';

export const useGetReview = () => {
    const {
        data,
        loading: isLoading,
        error,
    } = useQuery<getReviewQuery, Record<any, any>>(GET_REVIEW);

    return {
        review: data && data.g2Review,
        isLoading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
